angular.module("acl.visualizer.treemap.dataConfig", [
  "acl.common.localize",
  "acl.visualizer.dataModel",
  "acl.visualizer.multiSelect",
  "templates-visualizer",
]);
